import * as colors from "../constants/colors";
import * as languages from "../constants/languages";
import { english, spanish } from "../constants/strings";
import { css, StyleSheet } from "aphrodite";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	certificateNumberContainer: {
		flex: 1,
		paddingRight: 24,
		paddingTop: 12,
		paddingBottom: 2,
		paddingLeft: 2,
	},
	completionDateContainer: {
		borderTop: `1px solid ${colors.gray2}`,
		marginTop: 8,
		flex: 1,
		paddingTop: 12,
		paddingBottom: 2,
	},
	info: {
		fontSize: 16,
		fontFamily: "freight-sans-pro",
		lineHeight: 1.13,
		color: colors.black6,
	},
	label: {
		fontFamily: "priori-sans",
		fontWeight: "bold",
		fontSize: 16,
		lineHeight: 1.13,
		color: colors.black6,
	},
	titleContainer: {
		borderBottom: `1px solid ${colors.gray2}`,
		fontSize: 24,
		lineHeight: 1.29,
		fontWeight: "bold",
		fontFamily: "priori-sans",
		paddingBottom: 24,
		textAlign: "center",
	},
});

export default class CertificateInfo extends PureComponent {
	static propTypes = {
		courseTitle: PropTypes.string.isRequired,
		completionDate: PropTypes.string.isRequired,
		certificateNumber: PropTypes.string.isRequired,
		className: PropTypes.string,
		language: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;
	}

	render() {
		return (
			<div className={this.props.className}>
				<div className={css(styles.titleContainer)}>{this.props.courseTitle}</div>
				<div>
					<div className={css(styles.certificateNumberContainer)}>
						<div className={css(styles.label)}>{this.strings.Certificate_Number}</div>
						<div className={css(styles.info)}>{this.props.certificateNumber}</div>
					</div>
					<div className={css(styles.completionDateContainer)}>
						<div className={css(styles.label)}>{this.strings.Completion_Date}</div>
						<div className={css(styles.info)}>{this.props.completionDate}</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/CertificateInfo.js